import axios from "axios";
import { useEffect, useState } from "react";
// Hooks
import useDebouncedSearch from "../../components/Utils/hooks/useDebouncedSearch";
import usePageChange from "../../components/Utils/hooks/usePageChange";
import usePaginatedData from "../../components/Utils/hooks/usePaginatedData";

// Components
import Breadcrumbs from "../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import CommonFilterModal from "../../components/Common/CommonFilterModal";
import FilterOptions from "../../components/Common/CommonFilterOptions";
import Pagination from "../../components/Common/CommonPagination";
import ExcelDownload from "../../components/Utils/excelDownload";
import MainconternLayout from "../../components/Layout/MainconternLayout";
import NavBarTitles from "../../components/Common/TabBar";
import ExcelDownloadModal from "../../Pages/Masters/Common/excelDownloadAccess";

// Modals
import AssignedTo from "../../components/Modal/AssignedTo";
import Deletepopup from "../../components/Modal/Deletepopup";
import LeadStatus from "../../components/Modal/LeadStatus";
import LeadStatusConfirm from "../../components/Modal/LeadStatusConfirm";
import SucessModal from "../../components/Modal/SucessModal";

// Constants
import {
  HealthSynergynavBarData,
  InstaDoc,
  InstaDocRegistrationcolumnOrder,
  InstaDocRegistrationTable,
} from "./HealthSynergyConst";
import apiCall from "../../components/Api";
import "./healthsy.scss";
import useDeleteHandler from "../../components/Utils/hooks/useDeleteHandler";

const InstaDocRegistration = () => {
  const limit = 10;
  const [sort, setSort] = useState("newest");
  const [sortName, setSortName] = useState("Sort by");
  const [filtered_records, setFilteredRecords] = useState([]);
  const [assignModal, setAssignModal] = useState({ id: "", status: false });
  const [leadStatusModal, setLeadStatusModal] = useState({
    id: "",
    status: false,
  });
  const [success, setSuccess] = useState(false);
  const [leadStatussuccess, setLeadStatusSuccess] = useState(false);
  const [leadStatusConfirmModal, setLeadStatusConfirmModal] = useState({
    leadType: "",
    status: false,
    id: "",
  });
  const [leadStatus, setLeadStatus] = useState([]);
  const [filterLeadStatus, setFilterLeadStatus] = useState([]);
  const [bdModal, setBdModal] = useState([]);
  const filterBdModal = [];
  const skip = 0;
  const [search, setSearch] = useState(0);
  const [loader, setLoader] = useState(true);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFilterModalVisible, setIsFilterModalVisible] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("Lead Status");
  const [selectedValues, setSelectedValues] = useState({
    "Lead Status": [],
    BD: [],
  });

  const Filters = {
    "Lead Status": leadStatus,
    BD: bdModal,
  };

  const handleSortClick = (selectedSort) => {
    setSort(selectedSort);
    setSortName(
      {
        newest: "Newest First",
        oldest: "Oldest First",
        ascending: "Alphabetic A-Z",
        descending: "Alphabetic Z-A",
      }[selectedSort] || "Sort by",
    );
  };
  useEffect(() => {
    // getInstaDocList();
    getLeadStatus();
    getBdModal();
  }, []);

  const getLeadStatus = () => {
    axios
      .post(`${process.env.REACT_APP_API_URL}lead-status/list`, {
        noLimit: true,
      })
      .then((res) => {
        setLeadStatus(res.data.rows.map((lead) => lead?.type));
      });
  };

  const getBdModal = () => {
    axios
      .post(`${process.env.REACT_APP_API_URL}bd/list`, { noLimit: true })
      .then((res) => {
        setBdModal(res.data.rows.map((data) => data?.bd_name));
      });
  };

  const { records, totalCount, pagination, setPagination, fetchData } =
    usePaginatedData({
      apiUrl: `${process.env.REACT_APP_API_URL}insta-doc-registration/list`,
      initialParams: {
        sort,
        searchText: search,
        selectedValues,
      },
    });

  useEffect(() => {
    !assignModal.status && !leadStatusModal.status && setLoader(true);
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    pagination.skip,
    pagination.limit,
    sort,
    search,
    success,
    leadStatussuccess,
  ]);

  const list_api_call = async (clearFilter = false) => {
    await apiCall(`insta-doc-registration/list`, "POST", {
      skip: skip,
      limit: limit,
      sort: sort,
      searchText: search,
      values: clearFilter
        ? {}
        : {
            lead_status: filterLeadStatus,
            assigned_to: filterBdModal,
          },
    });
    setFilteredRecords([]);
  };

  const onClickDownload = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}insta-doc-registration/list`,
        {
          skip: 0,
          limit: 3000,
          searchText: search,
          values: {
            lead_status: filterLeadStatus,
            assigned_to: filterBdModal,
          },
          sort: sort,
        },
      );
      if (!response?.data?.rows?.length) {
        throw new Error("No records available to download.");
      }
      const records = response.data.rows;
      const formattedRecords = records.map((record, index) => ({
        "S.No": index + 1,
        "Time of Registration": record.createdAt
          ? new Date(record.createdAt).toLocaleTimeString()
          : "",
        "Date of Registration": record.createdAt
          ? new Date(record.createdAt).toLocaleDateString()
          : "",
        "Name of the Doctor": record.name || "",
        "Contact Number": record.mobile || "",
        "Email ID": record.email || "",
        Degree: record.degree || "",
        "Other Education": record.other_course || "",
        Gender: record.gender || "",
        "Primary Specialisation": record.specialization || "",
        "MCI / SMC Number": record.mci || "",
        "Year of Registration with Medical Council":
          record.registered_year || "",
        "Are you okay to receive online consultations from 9 PM - 9 AM ( Night - Day )":
          record.receive_online_consultations || "",
        State: record.state || "",
        City: record.city || "",
        Location: record.location || "",
        Pincode: record.pincode || "",
        Language: record.languages_known[0] || "",
        "BD Name": "",
        "App Download Android Click": record.android_click || 0,
        "Brochure Icon Click Status (1.0)": record.brochure_click || 0,
        "Assigned To": record.assigned_to || "",
        "Lead Status": record.lead_status || "",
        // Actions: "",
      }));

      ExcelDownload(
        formattedRecords,
        InstaDocRegistrationcolumnOrder,
        "instaDoc-registration.xlsx",
      );
    } catch (err) {
      console.error(
        "Error downloading the file while getting all Doctor registration records",
        err,
        "err.message",
        err?.message,
      );
      alert(err?.message || "An error occurred while downloading the file.");
    }
  };
  const [del, setDel] = useState(false);
  const [id, setId] = useState("");

  const handleDelete = useDeleteHandler(
    "insta-doc-registration",
    fetchData,
    setDel,
  );

  const successModalClose = () => {
    setSuccess(false);
    setLeadStatusSuccess(false);
    list_api_call();
  };

  const handlePageChange = usePageChange(pagination, setPagination);

  const debouncedSearch = useDebouncedSearch(setSearch, () => {
    setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
  });

  useEffect(() => {
    records && setTimeout(() => setLoader(false));
  }, [records]);

  return (
    <>
      <MainconternLayout
        header={
          <div className="d-flex pb-2 flex-wrap align-items-center justify-content-between">
            <Breadcrumbs
              className="healthsyMasterBreadCrumbs"
              breadcrumbsList={InstaDoc}
            />
          </div>
        }
        footer={
          <div className="mt-4 col d-flex align-items-center pagination justify-content-between admin-pagination">
            <div className="border border-danger bg-bg-light px-2 py-1 rounded">
              Total InstaDoc : {totalCount}
            </div>
            {totalCount > pagination.limit && (
              <Pagination
                skip={pagination.skip}
                limit={limit}
                total={totalCount}
                onPageChange={(selected) => handlePageChange({ selected })}
              />
            )}
          </div>
        }
      >
        <div className="healtharticle-container healthsyContainer">
          <NavBarTitles titles={HealthSynergynavBarData} />
          <FilterOptions
            limit={pagination.limit}
            sortName={sortName}
            search={search}
            setFilterShow={() => setIsFilterModalVisible(true)}
            onChange={debouncedSearch}
            setLimit={(val) =>
              setPagination((prev) => ({
                ...prev,
                limit: val,
                skip: 0,
                currentPage: 1,
              }))
            }
            downloadExcel={true}
            onClickDownload={() => setIsModalOpen(true)}
            handleSortClick={handleSortClick}
          />
          <InstaDocRegistrationTable
            filtered_records={filtered_records}
            records={records}
            skip={pagination.skip}
            setAssignModal={setAssignModal}
            setLeadStatusModal={setLeadStatusModal}
            setId={setId}
            setDel={setDel}
            fetchData={fetchData}
            loader={loader}
          />
        </div>
      </MainconternLayout>
      {del === true && (
        <Deletepopup
          handleDelete={handleDelete}
          id={id}
          handleClose={() => setDel(false)}
        />
      )}

      <CommonFilterModal
        visible={isFilterModalVisible}
        onClose={() => {
          setIsFilterModalVisible(false);
          setSelectedCategory(Object.keys(Filters)[0]);
        }}
        onApply={() => {
          setIsFilterModalVisible(false);
          setSelectedCategory(Object.keys(Filters)[0]);
          setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
          fetchData();
        }}
        onReset={() => {
          setSelectedValues({
            "Lead Status": [],
            BD: [],
          });
          setFilterLeadStatus([]);
          setFilteredRecords([]);
          setPagination((prev) => ({ ...prev, skip: 0, currentPage: 1 }));
          setSelectedCategory(Object.keys(Filters)[0]);
        }}
        filters={Filters}
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        selectedValues={selectedValues}
        setSelectedValues={setSelectedValues}
      />

      {assignModal.status === true && (
        <AssignedTo
          id={assignModal?.id}
          setAssignModal={setAssignModal}
          setSuccess={setSuccess}
          pathName="/insta-doc"
        />
      )}

      {success && (
        <SucessModal
          name="BD"
          post="Assigned"
          onClick={() => successModalClose()}
          page="/insta-doc"
        />
      )}

      {leadStatusModal.status === true && (
        <LeadStatus
          id={leadStatusModal?.id}
          setLeadStatusModal={setLeadStatusModal}
          setLeadStatusSuccess={setLeadStatusSuccess}
          setLeadStatusConfirmModal={setLeadStatusConfirmModal}
        />
      )}
      {leadStatusConfirmModal.status === true && (
        <LeadStatusConfirm
          id={leadStatusConfirmModal?.leadType}
          setLeadStatusConfirmModal={setLeadStatusConfirmModal}
          setLeadStatusSuccess={setLeadStatusSuccess}
          leadStatusConfirmModal={leadStatusConfirmModal}
          formType="insta-doc-registration"
        />
      )}
      {leadStatussuccess && (
        <SucessModal
          name="Lead Status"
          post="Updated"
          onClick={() => successModalClose()}
          page="/insta-doc"
        />
      )}
      <ExcelDownloadModal
        onClickDownload={onClickDownload}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </>
  );
};

export default InstaDocRegistration;
